import { IPaginationProps } from '../../types/base.interface';
import { IGroup } from '../../types/group.interface';
import { IUsers } from '../../types/user.interface';
import { api } from '../api';

export interface IGetUsersInGroupRequest extends IPaginationProps {
  groupId: string;
}

export interface IGroupPage {
  groups: IGroup[];
  number: number;
}

export const groupApi = api.injectEndpoints({
  endpoints: builder => ({
    getActiveGroup: builder.query<IGroup[], void>({
      query: () => `/users/groups/active`,
      providesTags: (result, error, arg) =>
        result ? [...result.map(({ id }) => ({ type: 'Group' as const, id })), 'Group'] : ['Group'],
    }),
    getArchivedGroup: builder.query<IGroup[], void>({
      query: () => `/users/groups/archived`,
      providesTags: (result, error, arg) =>
        result ? [...result.map(({ id }) => ({ type: 'Group' as const, id })), 'Group'] : ['Group'],
    }),
    // Админские списки групп (без привязки к текущему пользователю)
    getActiveAdminGroups: builder.query<IGroupPage, { pageNumber: number; pageSize: number }>({
      query: ({ pageNumber, pageSize }) => `/groups/active/${pageNumber}/${pageSize}`,
      providesTags: ['Group'],
    }),
    getArchivedAdminGroups: builder.query<IGroupPage, { pageNumber: number; pageSize: number }>({
      query: ({ pageNumber, pageSize }) => `/groups/archived/${pageNumber}/${pageSize}`,
      providesTags: ['Group'],
    }),
    getUsersInGroup: builder.query<IUsers, IGetUsersInGroupRequest>({
      query: ({ groupId, pageNumber, pageSize }) => `/groups/${groupId}/users/${pageNumber}/${pageSize}`,
      providesTags: (result, error, arg) =>
        result
          ? [...result.users.map(({ id }) => ({ type: 'UsersInGroup' as const, id })), 'UsersInGroup']
          : ['UsersInGroup'],
    }),
    createGroup: builder.mutation<{ id: string }, { name: string; startTime: string; endTime: string }>({
      query: body => ({
        url: `/groups`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Group'],
    }),
    updateGroup: builder.mutation<void, { id: string; name: string; startTime: string; endTime: string }>({
      query: ({ id, ...rest }) => ({
        url: `/groups/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: ['Group'],
    }),
    deleteGroup: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({ url: `/groups/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Group'],
    }),
    addUserToGroup: builder.mutation<void, { userId: string; groupId: string }>({
      query: ({ userId, groupId }) => ({
        url: `/users/${userId}/group/${groupId}/add`,
        method: 'PUT',
      }),
      invalidatesTags: ['UsersInGroup'],
    }),
    removeUserFromGroup: builder.mutation<void, { userId: string; groupId: string }>({
      query: ({ userId, groupId }) => ({
        url: `/users/${userId}/group/${groupId}/remove`,
        method: 'PUT',
      }),
      invalidatesTags: ['UsersInGroup'],
    }),
  }),
});
